import * as React from "react";
import { User } from "firebase/auth";
import { AuthContext } from "./AuthContext";
import { auth } from "../../firebase";

interface AuthProviderProps {
    children: React.ReactNode;
}

export default function AuthProvider({ children }: AuthProviderProps) {
    const [user, setUser] = React.useState<User | null | undefined>(undefined);

    React.useEffect(() => {
        const subscribeToAuthChange = auth.onAuthStateChanged(
            async (firebaseUser) => {
                if (firebaseUser) {
                    try {
                        await firebaseUser.getIdToken();
                        setUser(firebaseUser);
                    } catch (error) {
                        auth.signOut();
                    }
                } else {
                    setUser(null);
                }
            }
        );

        return subscribeToAuthChange;
    }, []);

    if (user === undefined) {
        return null;
    }

    return <AuthContext.Provider value={user}>{children}</AuthContext.Provider>;
}
